export default __webpack_public_path__ + "static/media/thop-vertical.4bb0330b.png";